import React, { Fragment } from 'react'

import SprintEnabledBlock from './SprintEnabledBlock'
import ActivityAndStreak from './ActivityAndStreak'
import ActivitiesGraph from './ActivitiesGraph'
import ActivityColorPanel from './ActivityColorPanel'
import Sprint from './Sprint'
import SprintAchieved from './SprintAchieved'

const MyProgressDashboard = ({ isSprintAchieved, isShownSprintInformation, sprintResult, sprint, badges }) => (
  <Fragment>
    {isSprintAchieved && <SprintAchieved sprintResult={sprintResult} />}
    {isShownSprintInformation && <Sprint sprint={sprint} />}
    <ActivityAndStreak />
    {badges && badges.achievedBadges && !!badges.achievedBadges.length && <SprintEnabledBlock badges={badges} />}
    <ActivitiesGraph />
    <ActivityColorPanel />
  </Fragment>
)

export default MyProgressDashboard
